export default function renderTextTemplate(tmpl, context) {
  return new Function(...Object.keys(context), `return \`${tmpl}\`;`)(...Object.values(context));
}
